import { Box } from '@mui/material'
import { ICowLightInfo } from 'models/ICattlesData'
import { useAppSelector } from 'store/hooks'
import FoodInfoWidjet from '../shared/FoodInfoWidjet'
import InfoWidjet from '../shared/InfoWidjet'
import PhotoWidjet from '../shared/PhotoWidjet'

type MainInfoPropsType = {
	cattleInfo: ICowLightInfo
}

const CowMainInfo = (props: MainInfoPropsType) => {
	const { cattleInfo } = props
	const { permissions } = useAppSelector(state => state.authReducer)
	return (
		<Box
			sx={{
				width: '100%',
				height: '245px',
				display: 'grid',
				gridAutoFlow: 'column',
				gridAutoColumns: 'minmax(0, 1fr)',
				gap: '24px',
				'& > *': {
					minWidth: 0,
					width: '100% !important',
					margin: 0,
				},
				'@media(max-width: 1200px)': {
					gridAutoFlow: 'row',
					gridAutoColumns: 'auto',
					gridTemplateColumns: 'minmax(0, 1fr)',
					height: 'auto',
				},
			}}
		>
			<PhotoWidjet images={cattleInfo?.images} />
			<InfoWidjet cattleInfo={cattleInfo} />
			{permissions?.license_food_table && (
				<FoodInfoWidjet cattleInfo={cattleInfo} />
			)}
		</Box>
	)
}

export default CowMainInfo
